import axios from "axios";

const API_URL =
  import.meta.env.VITE_API_URL ||
  "https://srv1309580.hstgr.cloud/puffin/api/v1";

// Public instance - no auth interceptors/token logic
const publicApi = axios.create({
  baseURL: API_URL,
  timeout: 30000,
});

import api from "./api";

// Build the full public share URL for a review link
export const buildPublicUrl = (publicLink) => {
  if (!publicLink) return "";
  const cleaned = publicLink.replace("/probation/review/", "");
  return `${window.location.origin}/probation/review/${cleaned}`;
};

// ==================== PUBLIC (No Auth) ====================

export const getPublicProbationReview = async (publicLink) => {
  const response = await publicApi.get(`/probation-reviews/public/${publicLink}`);
  return response.data;
};

export const submitPublicProbationReview = async (publicLink, payload) => {
  const response = await publicApi.post(
    `/probation-reviews/public/${publicLink}/submit`,
    payload,
  );
  return response.data;
};

// ==================== AUTHENTICATED (Admin/HR) ====================

export const createProbationReview = async (data) => {
  const response = await api.post("/probation-reviews", data);
  return response.data;
};

export const getProbationReviews = async (params = {}) => {
  const response = await api.get("/probation-reviews", { params });
  return response.data;
};

export const getProbationReviewById = async (id) => {
  const response = await api.get(`/probation-reviews/${id}`);
  return response.data;
};

export const updateProbationReview = async (id, data) => {
  const response = await api.put(`/probation-reviews/${id}`, data);
  return response.data;
};

export const deleteProbationReview = async (id) => {
  const response = await api.delete(`/probation-reviews/${id}`);
  return response.data;
};

export const updateProbationReviewStatus = async (id, status) => {
  const response = await api.patch(`/probation-reviews/${id}/status`, { status });
  return response.data;
};

export const sendProbationReview = async (id, payload) => {
  const response = await api.post(`/probation-reviews/${id}/send`, payload);
  return response.data;
};

export const getProbationReviewStats = async (year) => {
  const response = await api.get("/probation-reviews/stats", {
    params: { year },
  });
  return response.data;
};